import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import LoadingSpinner from '../components/LoadingSpinner';

export const CsrfContext = createContext();

export const CsrfProvider = ({ children }) => {
  const [csrfToken, setCsrfToken] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCsrfToken = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      console.log('=== FETCHING CSRF TOKEN ===');
      console.log('URL:', `${process.env.REACT_APP_API_BASE_URL}/api/v1/csrf-token`);
      
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/csrf-token`,
        { withCredentials: true }
      );
      
      console.log('CSRF Response received:', response.data);
      
      const token = response.data.csrfToken;
      const sessionId = response.data.sessionId;
      
      if (!token) {
        throw new Error('No CSRF token in response');
      }
      
      setCsrfToken(token);
      sessionStorage.setItem('csrfToken', token);
      
      console.log('✓ CSRF token stored successfully');
      console.log('  Token:', token.substring(0, 20) + '...');
      console.log('  Session ID:', sessionId);
      console.log('===========================');
      
    } catch (error) {
      console.error('❌ Error fetching CSRF token:', error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Always fetch fresh token on mount
    fetchCsrfToken();
  }, []);

  const refreshCsrfToken = () => {
    fetchCsrfToken();
  };

  // Show loading spinner while fetching CSRF token
  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Show error if CSRF token fetch failed
  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Failed to initialize security</h2>
        <p>{error.message}</p>
        <button onClick={fetchCsrfToken}>Retry</button>
      </div>
    );
  }

  return (
    <CsrfContext.Provider value={{ csrfToken, isLoading, refreshCsrfToken }}>
      {children}
    </CsrfContext.Provider>
  );
};